import { $ } from '@starberry/components';

export default {
  $: 'Box',
  props: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    bgImage: `url("${require('base/defaults/login-bg.jpg').default}")`,
    bgRepeat: 'no-repeat',
    bgSize: 'cover',
    bgPosition: 'center',
    minH: '100vh',
    py: 8,
    px: { sm: '6', lg: '8' },
    _after: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
      zIndex: '1',
    },
  },
  children: [
    {
      $: 'Box',
      props: {
        position: 'relative',
        maxW: { sm: 'xl' },
        mx: { sm: 'auto' },
        w: { sm: 'full' },
        zIndex: 5,
      },
      children: [
        {
          $: 'Box',
          props: {
            bg: 'white',
            py: { base: '4', sm: '20' },
            px: { base: '8', sm: '24' },
            shadow: 'base',
            rounded: { sm: 'lg' },
          },
          children: [
            {
              $: 'H5',
              children: $('constants.translations.resetPass.RESET_PASS_TITLE', 'Reset Password'),
              props: {
                as: 'h2',
                pb: '2',
                textAlign: 'center',
              },
            },
            {
              $: 'Box',
              children: [
                {
                  $: 'Text',
                  children: $(
                    'constants.translations.resetPass.RESET_PASS_SUBTITLE',
                    'To complete the password reset process, please enter a new password.'
                  ),
                },
              ],
              props: {
                fontSize: '0.875rem',
                textAlign: 'center',
                mb: '8',
              },
            },
            { $: 'ResetPassForm' },
            { $: 'TermsForm', startText: 'By clicking “Change Password” you agree to our ' },
          ],
        },
      ],
    },
  ],
};
